import CurrentConsumptionReport from './CurrentConsumptionReport.js';
import PreviousConsumptionReport from './PreviousConsumptionReport.js';

export default class ConsumptionReportList {
  /**
   * @param {string} sn
   * @param {object[]} data
   * @param {boolean} isPrepaid
   */
  constructor(sn, data, isPrepaid) {
    this.sn = sn;
    this._data = data.sort((a, b) => new Date(b.effectiveDate) - new Date(a.effectiveDate));
    this.isPrepaid = isPrepaid;
  }

  /**
   * @return {CurrentConsumptionReport}
   */
  get currentConsumptionReport() {
    if (!Array.isArray(this._data) || this._data.length < 1) {
      throw new Error(
        `UsageConsumptionReport response for SN ${this.sn} does not contain a report.`,
      );
    }
    if (this._data.length > 1) {
      throw new Error(
        `UsageConsumptionReport response for SN ${this.sn} contains more than one report.`,
      );
    }

    return new CurrentConsumptionReport(this.sn, this._data[0], this.isPrepaid);
  }

  /**
   * @return {PreviousConsumptionReport[]}
   */
  get previousConsumptionReports() {
    if (!Array.isArray(this._data) || this._data.length < 1) {
      throw new Error(
        `UsageConsumptionReport response for SN ${this.sn} does not contain a report.`,
      );
    }

    return this._data.map(item => new PreviousConsumptionReport(this.sn, item, this.isPrepaid));
  }

  /**
   * @return {boolean}
   */
  get hasPreviousConsumptionMessages() {
    return this.previousConsumptionReports.some(report => report.hasMessages);
  }

  /**
   * @return {boolean}
   */
  get hasPreviousConsumptionVoice() {
    return this.previousConsumptionReports.some(report => report.hasVoice);
  }

  /**
   * @return {boolean}
   */
  get hasPreviousConsumptionData() {
    return this.previousConsumptionReports.some(report => report.hasData);
  }

  /**
   * @return {boolean}
   */
  get hasPreviousConsumptionTopCalled() {
    return this.previousConsumptionReports.some(report => report.hasTopCalled);
  }

  /**
   * @return {PreviousConsumptionReport[]}
   */
  get previousConsumptionMessages() {
    return this.previousConsumptionReports.filter(report => report.hasMessages);
  }

  /**
   * @return {PreviousConsumptionReport[]}
   */
  get previousConsumptionVoice() {
    return this.previousConsumptionReports.filter(report => report.hasVoice);
  }

  /**
   * @return {PreviousConsumptionReport[]}
   */
  get previousConsumptionData() {
    return this.previousConsumptionReports.filter(report => report.hasData);
  }

  /**
   * @return {string[]}
   */
  get previousConsumptionLatestTopCalledNumbers() {
    return this.previousConsumptionReports
      .find(report => report.hasTopCalled)
      .topCalledBuckets.map(bucket => bucket.topCalledSn);
  }

  /**
   * @return {PreviousConsumptionReport[]}
   */
  get previousConsumptionAirtime() {
    return this.previousConsumptionReports.filter(report => report.hasAirtime);
  }
}
